<template>
  <div>
    <div style="width: 100%; height: 580px" class="banner">
      <slider ref="slider" :options="options" v-if="someList && someList.length > 0">
        <!-- 直接使用slideritem slot -->
        <slideritem v-for="(item,index) in someList" :key="index" :style="item.style">
          <a style="display: block; width: 100%; height: 100%;" @click="orgurl.navTo(item.href)">{{item.title}}</a>
        </slideritem>
        <!-- 设置loading,可自定义 -->
        <div slot="loading">loading...</div>
      </slider>
    </div>
    <!--在线培训-->
    <div class="in_con_2">
      <div class="wrap w1200">
        <div class="in_title">
          <dl>
            <dt>在线培训</dt>
            <dd>精心打造实时更新便捷的培训模式，助力企业</dd>
          </dl>
        </div>
        <!--职称教育-->
        <div class="in_zy_a" style="cursor:pointer" @click="goWebEdu()">
          <div class="top_img"><img src="@/assets/images/px_3.jpg" title="职称教育" /></div>
          <div class="top_icon"><img src="@/assets/images/px_icon_c@2x.png"/></div>
          <div class="con">
            <dl>
              <dt>职称教育</dt>
              <dd>职业培训教育，大型职业培训考试网站,常年开设公务员,经济师,职称英语,职称计算机,招标师,人力资源管理师,心理咨询师,注册消防工程师等国家职业资格考试网上辅导培训</dd>
            </dl>
          </div>
        </div>
        <!--/职称教育-->
        <!--企业内训-->
        <div class="in_zy_b" style="cursor:pointer" @click="goTraining()">
          <div class="top_img"><img src="@/assets/images/px_4.jpg" title="企业内训" /></div>
          <div class="top_icon"><img src="@/assets/images/px_icon_d@2x.png"/></div>
          <div class="con">
            <dl>
              <dt>企业内训</dt>
              <dd>企业内训 解决企业当前问题,提升人员胜任能力,通过团队行动学习,使培训成效显著提升,效果实现可视化,解决企业的实际问题</dd>
            </dl>
          </div>
        </div>
        <!--/企业内训-->
        <!--安全-->
        <div class="in_zy_c">
          <div class="top_img"><img src="@/assets/images/px_1.jpg" title="安全" /></div>
          <div class="top_icon"><img src="@/assets/images/px_icon_a@2x.png"/></div>
          <div class="con">
            <dl>
              <dt>安全</dt>
              <dd>安全，就是指企业员工在生产过程中或生产过程中的设备没有危险、不受威胁、不出事故。比如生产过程中的人身和设备安全、道路交通中的人身和车辆安全等等。</dd>
            </dl>
          </div>
        </div>
        <!--/安全-->
        <!--党员党建-->
        <div class="in_zy_d">
          <div class="top_img"><img src="@/assets/images/px_2.jpg"  title="党员党建"/></div>
          <div class="top_icon"><img src="@/assets/images/px_icon_b@2x.png"/></div>
          <div class="con">
            <dl>
              <dt>党员党建</dt>
              <dd>党建致力于增强基层党组织的凝聚力,提供智慧党建信息管理系统云平台开发!专注于党建互联网+信息化管理,为党建管理的移动信息化建设提供一站式智慧解决方案</dd>
            </dl>
          </div>
        </div>
        <!--/党员党建-->
      </div>
    </div>
    <!--/在线培训-->

    <!--课件资源-->
    <div class="in_con_3">
      <div class="wrap w1200 rdiv">
        <div class="in_title">
          <dl>
            <dt>课件资源</dt>
            <dd>精心打造实时更新便捷的培训模式，助力企业</dd>
          </dl>
        </div>
        <!--推荐课程-->
        <div class="col_1 w580 zy_tj" v-if="recommendCourse">
          <a href="javascript:;" @click="course_detail(recommendCourse.id)">
            <div class="img">
              <img v-if="recommendCourse.faceUrl" :src="recommendCourse.faceUrl" :title="recommendCourse.name"/>
              <img v-if="!recommendCourse.faceUrl || recommendCourse.faceUrl==''" src="@/assets/images/class_img.jpg" :title="recommendCourse.name"/>
              <span class="tj_tit">推荐课程</span>
              <span class="price" v-if="recommendCourse.coursePriceList && recommendCourse.coursePriceList[0].price && recommendCourse.coursePriceList[0].price != '0'">￥{{recommendCourse.coursePriceList[0].price}}</span>
              <span class="price" v-if="!recommendCourse.coursePriceList || !recommendCourse.coursePriceList[0].price || recommendCourse.coursePriceList[0].price == '0'">免费</span>
              <span class="man_num">{{recommendCourse.learnCount}}</span>
            </div>
            <div class="tit_con">
              <dl>
                <dt class="single_ellipsis">{{recommendCourse.name}}</dt>
                <dd v-if="recommendCourse.teacherList && recommendCourse.teacherList.length>0">讲师：{{recommendCourse.teacherList[0].teacherName}}<span v-if="recommendCourse.teacherList.length>1">等</span></dd>
                <dd v-if="!recommendCourse.teacherList">讲师：暂无</dd>
              </dl>
            </div>
          </a>
        </div>
        <!--/推荐课程-->
        <!--右侧课程列表-->
        <div class="col_2 w600 zy_tj_right" v-if="commonCourses && commonCourses.length>0">
          <a href="javascript:;" v-for="item in commonCourses" :key="item.id" @click="course_detail(item.id)">
            <dl>
              <dt>
                <img v-if="item.faceUrl" :src="item.faceUrl" :title="item.name" />
                <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/class_img.jpg" :title="item.name" />
                <span class="price_r" v-if="item.coursePriceList && item.coursePriceList[0].price && item.coursePriceList[0].price != '0'">￥{{item.coursePriceList[0].price}}</span>
                <span class="price_r" v-if="!item.coursePriceList || !item.coursePriceList[0].price || item.coursePriceList[0].price == '0'">免费</span>
                <span class="man_num_r">{{item.learnCount}}</span>
              </dt>
              <dd>
                <h3 class="single_ellipsis">{{item.name}}</h3>
                <p v-if="item.teacherList && item.teacherList.length>0">讲师：{{item.teacherList[0].teacherName}}<span v-if="item.teacherList.length>1">等</span></p>
                <p v-if="!item.teacherList">讲师：暂无</p>
              </dd>
            </dl>
          </a>
        </div>
        <!--/右侧课程列表-->
        <div class="clear"></div>
        <p><router-link to="/byl/courseList" class="more" style="margin-top:16px;">更多课程</router-link></p>

      </div>
    </div>
    <!--/课件资源-->

    <!--直播课程-->
    <div class="in_con_4">
      <div class="wrap w1200">
        <div class="in_title">
          <dl>
            <dt>直播课程</dt>
            <dd>精心打造实时更新便捷的培训模式，助力企业</dd>
          </dl>
        </div>
        <div class=""></div>
        <div class="on_line_list">
          <a href="javascript:;" v-for="item in livePlayList" :key="item.id" @click="livePlay_detail(item.id)">
            <dl>
              <dt>
                <img v-if="item.cover" :src="item.cover" :title="item.title" />
                <img v-if="!item.cover || item.cover==''" src="@/assets/images/live_img.jpg" :title="item.title" />
                <span class="price_r" v-if="item.cost && item.cost != '0'">￥{{item.cost}}</span>
                <span class="price_r" v-if="!item.cost || item.cost == '0'">免费</span>
                <span class="play_con"></span>
                <span class="man_num_r">{{item.livePersonCnt}}</span>
                <span class="play_ing" v-if="item.timeStateName=='进行中'">正在直播{{$utils.substring(item.startTime,10,16)}}-{{$utils.substring(item.endTime,10,16)}}</span>
                <span class="play_end" v-if="item.timeStateName=='已结束'">直播结束</span>
                <span class="play_w_time" v-if="item.timeStateName=='未开始'">{{$utils.substring(item.startTime,0,16)}}-{{$utils.substring(item.endTime,0,16)}}</span>
                <span class="play_none" v-if="item.timeStateName=='未开始'">未开始</span>

                <span class="play_go" v-if="item.timeStateName=='进行中'" @click="viewLivePlay()">观看直播</span>
                <!--<span class="play_go" v-if="item.timeStateName=='已结束'" @click="viewVideo()">观看视频</span>-->
              </dt>
              <dd>
                <h3 class="single_ellipsis">{{item.name}}</h3>
                <p v-if="item.livePlayTeacherList && item.livePlayTeacherList.length>0">讲师：{{item.livePlayTeacherList[0].teacherName}}<span v-if="item.livePlayTeacherList.length>1">等</span></p>
                <p v-if="!item.livePlayTeacherList">讲师：暂无</p>
              </dd>
            </dl>
          </a>
        </div>
        <div class="clear"></div>
        <p><router-link to="/byl/livePlayList" class="more" style="margin-top:16px;">更多直播</router-link></p>
      </div>
    </div>
    <!--/直播课程-->

    <!--高级精英讲师-->
    <div class="in_con_5">
      <div class="wrap w1200">
        <div class="in_title">
          <dl>
            <dt>高级精英讲师</dt>
            <dd>精心打造实时更新便捷的培训模式，助力企业</dd>
          </dl>
        </div>
        <div class="teacher_list_i">
          <a href="javascript:;" v-for="item in teacherList" :key="item.id" @click="teacher_detail(item.id)">
            <dl>
              <dt>
                <img v-if="item.faceUrl" :src="item.faceUrl" :title="item.name"/>
                <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/teacher_normal_img.jpg" :title="item.name"/>
              </dt>
              <dd>
                <h3>{{item.name}}</h3>
                <p>{{item.content}}</p>
              </dd>
            </dl>
          </a>
        </div>
      </div>
    </div>
    <!--/高级精英讲师-->
    <!--跟踪圆点-->
    <div class="in_yuandian" style="z-index: 9999;">
      <a class="focus" @click="maodian('banner',50, $event)"></a>
      <a @click="maodian('in_con_2',50, $event)"></a>
      <a @click="maodian('in_con_3',50, $event)"></a>
      <a @click="maodian('in_con_4',50, $event)"></a>
      <a @click="maodian('in_con_5',50, $event)"></a>
    </div>
    <!--/跟踪圆点-->
    <!--右侧漂浮菜单-->
    <div class="float_menu" style="z-index: 9999;">
      <p><a href="javascript:;"><img src="@/assets/images/float_right_icon_1@2x.png" alt="快速体验"/></a></p>
      <p class="float_menu_line"></p>
      <p><a href="javascript:;"><img src="@/assets/images/float_right_icon_2@2x.png" alt="APP下载"/></a></p>
      <p class="float_menu_line"></p>
      <p><a href="javascript:;"><img src="@/assets/images/float_right_icon_3@2x.png" alt="联系客服"/></a></p>
    </div>
    <!--/右侧漂浮菜单-->
  </div>
</template>
<script>
  import { slider, slideritem } from 'vue-concise-slider'// import slider components
import {init as scroll} from '@/assets/js/byl_index_scroll'
  import orgurl from '@/utils/orgurl'

export default {
  components: { slider, slideritem },
  data () {
    return {
      orgurl: orgurl,
      someList: [],
      recommendCourse: {coursePriceList: [{}]},
      commonCourses: [{coursePriceList: [{price: ''}]}],
      livePlayList: [],
      teacherList: [],
      options: {
        currentPage: 0,
        thresholdDistance: 500,
        thresholdTime: 100,
        autoplay: 10000,
        loop: true,
        direction: 'horizontal',
        loopedSlides: 1,
        slidesToScroll: 1,
        timingFunction: 'ease',
        speed: 300,
        renderPagination: (h, index) => {
          return h('span', {
            class: 'b-list-span'
          })
        },
        tap (data) {
          console.log(data)
        }
      }
    }
  },
  computed: {},
  created () {
    this.getCourses()
    this.getLivePlays()
    this.getTeachers()
  },
  mounted () {
    this.$nextTick(() => {
      scroll()
    })
    let that = this
    let a = []
    this.getBanners().then(function (r) {
      r.forEach((o) => {
        let no = {}
        no.style = {
          'background': 'url(' + o.cover + ') no-repeat center center',
          'cursor': 'pointer'
        }
        no.href = o.href
        a.push(no)
      })
    })
    that.someList = a
  },
  destroyed () {
    $(window).off('scroll') // 销毁时要解除绑定
  },
  methods: {
    getCourses () {
      this.$api.post(this.$global.courseApiPath, '/course/courses', {pageNo: 1, pageSize: 5, delFlag: '0'}, r => {
        if (r.data && r.data.length>0) {
          let courseList = r.data
          this.recommendCourse = courseList[0]
          if (r.data.length>1) {
            this.commonCourses = courseList.splice(1)
          }
        }
      })
    },
    getLivePlays () {
      this.$api.post(this.$global.livePlayApiPath, '/livePlayInfo/findList', {pageNo: 1, pageSize: 8, delFlag: '0', state: '1'}, r => {
        if (r.data && r.data.length>0) {
          this.livePlayList = r.data
        }
      })
    },
    getTeachers () {
      this.$api.post(this.$global.teacherApiPath, '/teacher/teachers', {pageNo: 1, pageSize: 4, delFlag: '0'}, r => {
        if (r.data && r.data.length>0) {
          this.teacherList = r.data
        }
      })
    },
    getBanners () {
      var that = this
      return new Promise(function (resolve, reject) {
        that.$api.post(that.$global.bylBaseCenterPath, '/recommendinfo/search', {audit: '1'}, r => {
          resolve(r.data)
        })
      })
    },
    course_detail (id) {
      this.$router.push({path: '/byl/courseDetail/'+ id})
    },
    livePlay_detail (id) {
      this.$router.push({path: '/byl/livePlayDetail/'+ id})
    },
    teacher_detail (id) {
      this.$router.push({path: '/byl/teacherDetail/'+ id})
    },
    // 像描点点击
    maodian (id, height, e) {
      let $elem = $(e.target)
      if (document.getElementsByClassName(id).length > 0) {
        let heights=document.getElementsByClassName(id)[0].offsetTop-height;
        $("html").animate({scrollTop: heights});
      }
      $elem.addClass('focus')
    },
    goWebEdu () { this.$router.push({path: '/byl/web_education'}) },
    goTraining () { this.$router.push({path: '/byl/training'}) }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/home.vue